import { Component, Inject, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, UserService } from '@app/_services';
import { PrimeNGConfig, MessageService, ConfirmationService } from 'primeng/api';
import { TestService } from '../test';

declare var require: any;

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
const htmlToPdfmake = require("html-to-pdfmake");
// (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
    selector: 'app-wifi-qr',
    templateUrl: './wifi-qr.component.html',
    styleUrls: ['./wifi-qr.component.css'],
    standalone: false
})
export class WifiQrComponent implements OnInit {

  property: any;
  qrCode: any;
  isSpinner = false;

  constructor(
		private primengConfig: PrimeNGConfig,
		private testService: TestService,
		private userService: UserService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.property = data.property;
		console.log("property property property :"+JSON.stringify(this.property));
	}

  @ViewChild('pdfTable')
  pdfTable!: ElementRef;

  public downloadAsPDF() {
    const pdfTable = this.pdfTable.nativeElement;
    var html = htmlToPdfmake(pdfTable.innerHTML);
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition).download();

  }


  ngOnInit(): void {
	this.getQRCode()
  }

  getQRCode() {
	this.isSpinner = true;
		const qrCodeInfo = {
			wifiName:this.property?.instruction?.wifiName,
			wifiName5g:this.property?.instruction?.wifiName5g,
			wifiPassword:this.property?.instruction?.wifiPassword
		}
		try {
			this.userService.getQRCode(qrCodeInfo)
				.subscribe(
					res => {
						console.log('qrCode: ' + JSON.stringify(res));
						this.qrCode = res.data.qrCode;
						this.isSpinner = false;
						return this.qrCode;
					},
					err => {
						this.isSpinner = false;
						console.log('QrCode FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSpinner = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}

}


}
